import { Icon } from '../../components/Icon'
import { fileTypeLabel, formatFileSize } from '../../lib/format'
import { formatDuration, knownDuration } from '../../lib/media'
import { retryUpload, useUploads, type PendingUpload } from './uploadsStore'

function statusText(upload: PendingUpload): string {
  switch (upload.status) {
    case 'preparing':
      return 'Preparing…'
    case 'uploading':
      return `Uploading ${Math.round(upload.progress * 100)}%`
    case 'done':
      return 'Ready to send'
    case 'error':
      return upload.error ?? 'Upload failed'
  }
}

export function PendingAttachmentList({ uploads }: { uploads: PendingUpload[] }) {
  const remove = useUploads((s) => s.remove)
  if (!uploads.length) return null
  return (
    <div className="pending-attachments" aria-label="Attachments to send">
      {uploads.map((u) => {
        const type = fileTypeLabel(u.fileName)
        const length = knownDuration(u.durationMs)
        return (
          <div key={u.localId} className={u.status === 'error' ? 'pending-file error' : 'pending-file'}>
            {u.previewUrl ? (
              <img src={u.previewUrl} alt="" />
            ) : (
              <span className="file-symbol" data-file-type={type}>
                {type}
              </span>
            )}
            <span className="file-info">
              <strong title={u.fileName}>{u.fileName}</strong>
              <small role={u.status === 'error' ? 'alert' : undefined}>
                {formatFileSize(u.sizeBytes)}
                {length !== null ? ` · ${formatDuration(length)}` : ''} · {statusText(u)}
              </small>
            </span>
            {u.status === 'error' ? (
              <button type="button" className="icon-button" aria-label={`Retry uploading ${u.fileName}`} onClick={() => retryUpload(u)}>
                <Icon name="refresh" />
              </button>
            ) : null}
            <button type="button" className="icon-button" aria-label={`Remove ${u.fileName}`} onClick={() => remove(u.channelId, u.localId)}>
              <Icon name="x" />
            </button>
            {u.status === 'uploading' || u.status === 'preparing' ? (
              <span className="upload-progress" style={{ width: `${Math.round(u.progress * 100)}%` }} aria-hidden="true" />
            ) : null}
          </div>
        )
      })}
    </div>
  )
}
